module.exports = __webpack_public_path__ + "img/anchor3.cde613a2.jpg";